import { useSelector } from "react-redux";

export const useFormEventStore = () => {
  const { isLoading, message } = useSelector((state) => state.doctor.formEvent);

  return {
    // Props
    isLoading,
    message,
  };
};
